import { render, staticRenderFns } from "./ElementItem.vue?vue&type=template&id=39da2ab8&"
import script from "./ElementItem.vue?vue&type=script&lang=js&"
export * from "./ElementItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports